module.exports = __webpack_public_path__ + "static/media/health-beauty.e7703e45.svg";